import { Card } from "@radix-ui/themes";
import PropTypes from "prop-types";

BottomCenterMapDiv.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
};

export default function BottomCenterMapDiv({ children, color }) {
  return (
    <Card
      id="bottom-center-map-div"
      style={{
        position: "absolute",
        bottom: "120px",
        left: 0,
        right: 0,
        margin: "auto",
        zIndex: 1000,
        backgroundColor: color ? color : "white",
        borderRadius: "var(--radius-4)",
        padding: "var(--space-2)",
        width: "fit-content",
        maxWidth: "350px",
      }}
    >
      {children}
    </Card>
  );
}
